import React from 'react';

/**
 * Konfigurasi warna untuk setiap tier
 * Background berwarna dengan text putih
 */
const TIER_CONFIG = {
    common: {
        label: 'Common',
        bg: 'bg-gray-500',
        shadow: 'shadow-gray-500/30',
    },
    uncommon: {
        label: 'Uncommon',
        bg: 'bg-emerald-500',
        shadow: 'shadow-emerald-500/30',
    },
    rare: {
        label: 'Rare',
        bg: 'bg-blue-500',
        shadow: 'shadow-blue-500/30',
    },
    epic: {
        label: 'Epic',
        bg: 'bg-purple-500',
        shadow: 'shadow-purple-500/30',
    },
    legend: {
        label: 'Legend',
        bg: 'bg-yellow-500',
        shadow: 'shadow-yellow-500/30',
    },
    mythical: {
        label: 'Mythical',
        bg: 'bg-red-500',
        shadow: 'shadow-red-500/30',
    },
    divine: {
        label: 'Divine',
        bg: 'divine-badge', // Uses animated gradient from FontStyle
        shadow: 'shadow-fuchsia-500/40',
    },
};

/**
 * Komponen Badge untuk menampilkan tier karakter
 * Background berwarna dengan text putih
 * 
 * @param {string} tier - Tier karakter (common, uncommon, rare, epic, legend, mythical, divine)
 * @param {boolean} isDarkMode - Status dark mode
 * @param {string} size - Ukuran badge ('sm', 'md', 'lg')
 * @param {string} className - Class tambahan
 */
const TierBadge = ({ tier = 'common', isDarkMode = false, size = 'sm', className = '' }) => {
    const config = TIER_CONFIG[tier.toLowerCase()] || TIER_CONFIG.common;

    // Size classes
    const sizeClasses = {
        sm: 'text-[9px] md:text-[10px] px-2 py-0.5 md:py-1',
        md: 'text-[10px] md:text-xs px-2.5 py-1',
        lg: 'text-xs md:text-sm px-3 py-1.5',
    };

    return (
        <span
            className={`
                inline-flex items-center font-bold rounded-full text-white
                ${config.bg}
                ${sizeClasses[size]}
                shadow-lg ${config.shadow}
                ${className}
            `}
        >
            {config.label}
        </span>
    );
};

// Export tier config untuk digunakan di komponen lain jika diperlukan
export { TIER_CONFIG };
export default TierBadge;
